import React from 'react';
import aboutImage from '../../Assests/Images/336482317_6715599158469108_5975128752838031663_n.jpeg'
import '../../App.css'
const About = () => {
     return (
          <div id='about'>
               <div class="bg-pink-700 p-2 md:p-16">
                    <div class='md:flex justify-center'>
                         <div
                         data-aos="fade-right"
                         data-aos-offset="300"
                         data-aos-duration='500'
                         data-aos-easing="ease-in-sine"
                         class=" sm:w-full md:w-12/12 text-white bg-pink-800 p-8 sm:rounded-tr-lg md:rounded-tr-none md:rounded-bl-lg rounded-tl-lg flex items-center">
                              <div>
                                   <h1 class="text-4xl text-left mb-5  font-bold">About Me</h1>
                                   
                                   <h2 class="text-lg mb-5 text-gray-300">As the owner of the Crazy Artist Studio, I strive to provide my clients with unique and high-quality photography and graphic design services that help them stand out in their respective industries. I am always exploring new techniques and technologies to keep my work fresh and innovative. <br /> <br />
                                   Thank you for taking the time to learn a bit about me. I am excited to connect with you and discuss how I can help bring your vision to life.</h2>
                                   <div class="flex">
                                        <div class="mr-8">
                                             <p class="text-2xl font-bold">10+</p>
                                             <p class="text-sm">companies</p>
                                        </div>
                                        <div class="mr-8">
                                             <p class="text-2xl font-bold">50+</p>
                                             <p class="text-sm">teams</p>
                                        </div>
                                        <div>
                                             <p class="text-2xl font-bold">100+</p>
                                             <p class="text-sm">events</p>
                                        </div>
                                   </div>
                              </div>
                         </div>
                         <div
                         data-aos="zoom-in"
                         data-aos-duration='1000'
                         class="md:w-6/12 relative">
                              <div class=" w-full h-full opacity-60 absolute sm:rounded-bl-lg md:rounded-bl-none md:rounded-tr-lg rounded-br-lg"></div>
                              <img class=" sm:w-80 md:w-full sm:rounded-bl-lg md:rounded-bl-none md:rounded-tr-lg rounded-br-lg" src={aboutImage} alt="About banner" />
                         </div>
                    </div>
               </div>




          </div>
     );
};

export default About;